import React, {useCallback} from 'react'
import styled from '@emotion/styled'
import {AnimatePresence, motion} from 'framer-motion'

import {cssTheme} from '../../../../themes'
import mirror from '../../../../utils/mirror'
import {Button} from '../../Button'
import {Icon as AtlasIcon} from '../../Icon'

export const PaginationWrapper = styled(motion.div)`
  position: absolute;
  padding: 0 ${cssTheme.layout.spacing.s300};
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mirror()}
`

const Icon = styled(AtlasIcon)`
  ${mirror()}
`

interface Props {
  currentIndex: number
  totalPages: number
  goToPane: (i: number) => void
  showPaginationButtons: boolean
}

export const PaginationButtons = ({
  showPaginationButtons,
  currentIndex,
  goToPane,
  totalPages
}: Props) => {
  const goToPrevPage = useCallback(
    (e: React.SyntheticEvent) => {
      e.stopPropagation()
      goToPane(currentIndex > 0 ? currentIndex - 1 : totalPages - 1)
    },
    [currentIndex, goToPane, totalPages]
  )

  const goToNextPage = useCallback(
    (e: React.SyntheticEvent) => {
      e.stopPropagation()
      goToPane(currentIndex < totalPages - 1 ? currentIndex + 1 : 0)
    },
    [currentIndex, goToPane, totalPages]
  )
  if (totalPages < 2) return null

  return (
    <AnimatePresence>
      {showPaginationButtons && (
        <PaginationWrapper
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
        >
          <Button
            dataId="paginationLeftButton"
            iconStart={<Icon name="ChevronLeft" />}
            size="sm"
            variant="secondary"
            isFloating
            isRounded
            onClick={goToPrevPage}
          />

          <Button
            dataId="paginationRightButton"
            iconStart={<Icon name="ChevronRight" />}
            size="sm"
            variant="secondary"
            isFloating
            isRounded
            onClick={goToNextPage}
          />
        </PaginationWrapper>
      )}
    </AnimatePresence>
  )
}
